import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface StorySubmissionCTAProps {
  onSubmitClick: () => void;
}

const StorySubmissionCTA: React.FC<StorySubmissionCTAProps> = ({ onSubmitClick }) => {
  return (
    <div className="bg-gradient-to-br from-primary to-secondary rounded-lg p-8 lg:p-12 text-center shadow-lg">
      <div className="max-w-3xl mx-auto">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-accent rounded-full flex items-center justify-center">
            <Icon name="PencilSquareIcon" size={32} className="text-accent-foreground" />
          </div>
        </div>

        <h2 className="text-3xl lg:text-4xl font-headline font-bold text-primary-foreground mb-4">
          Share Your Transformation Story
        </h2>

        <p className="text-lg text-primary-foreground/90 font-body leading-relaxed mb-8">
          Your journey of forgiveness and healing can inspire others around the world. Share how
          choosing to have no enemy transformed your life, family, or community.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="flex flex-col items-center space-y-2">
            <div className="w-12 h-12 bg-primary-foreground/20 rounded-full flex items-center justify-center">
              <Icon name="DocumentTextIcon" size={24} className="text-primary-foreground" />
            </div>
            <span className="text-sm font-body text-primary-foreground/90">
              Written or Video Format
            </span>
          </div>

          <div className="flex flex-col items-center space-y-2">
            <div className="w-12 h-12 bg-primary-foreground/20 rounded-full flex items-center justify-center">
              <Icon name="ShieldCheckIcon" size={24} className="text-primary-foreground" />
            </div>
            <span className="text-sm font-body text-primary-foreground/90">
              Moderated for Quality
            </span>
          </div>

          <div className="flex flex-col items-center space-y-2">
            <div className="w-12 h-12 bg-primary-foreground/20 rounded-full flex items-center justify-center">
              <Icon name="GlobeAltIcon" size={24} className="text-primary-foreground" />
            </div>
            <span className="text-sm font-body text-primary-foreground/90">
              Reach Global Audience
            </span>
          </div>
        </div>

        <button
          onClick={onSubmitClick}
          className="px-8 py-4 bg-accent text-accent-foreground rounded-md font-cta text-lg font-bold hover:scale-105 transition-transform duration-300 shadow-lg pulse-gentle"
        >
          Submit Your Story
        </button>

        <p className="mt-6 text-sm text-primary-foreground/70 font-body">
          All submissions are reviewed to ensure authenticity and alignment with our values
        </p>
      </div>
    </div>
  );
};

export default StorySubmissionCTA;